export default "__VITE_ASSET__CMhQG46l__"